import {SlctFormat, SlctOption} from 'module/Slct/type/SlctType'
import {stripHTML} from 'util/StringUtil'
import {renderToString} from 'react-dom/server'
import {getOptionLabel} from 'module/Slct/util/getOptionLabel'

export function getSlctOptionCopyText<ModelType extends object | void, ValueType extends string | number>(option: SlctOption<ModelType, ValueType> | null | undefined, displayFormat: SlctFormat) {
	if (!option) return undefined
	if (option.copy) return option.copy
	const labelJSX = getOptionLabel(displayFormat === SlctFormat.Label ? SlctFormat.Label : SlctFormat.Value, option)
	const displayText = stripHTML(renderToString(labelJSX))?.trim()
	if (displayText) return displayText
	return undefined
}